import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { paymentFlow } from '@/mocks/pricingDetailsData';

export default function PaymentFlow() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[900px] mx-auto px-8">
        <div className="text-center mb-14">
          {String(t('pricingDetails.flow.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('pricingDetails.flow.title')}
          </h2>
          {String(t('pricingDetails.flow.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('pricingDetails.flow.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] md:text-[16px] text-foreground-500 tracking-[0.04em] leading-relaxed mt-6 max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6">
          {paymentFlow.map((step, idx) => (
            <div
              key={idx}
              className="relative card-glow bg-background-100/50 border border-background-200/60 p-5 md:p-6"
            >
              {idx < paymentFlow.length - 1 && (
                <div className="hidden md:block absolute top-10 -right-3 z-10">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-s-line text-accent-400/40 text-sm"></i>
                  </div>
                </div>
              )}

              <div className="flex items-center gap-3 mb-4">
                <span className="text-[18px] text-accent-600 tracking-[0.06em] font-medium font-heading">
                  {step.step}
                </span>
                <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0">
                  <i className={`${step.icon} text-accent-500 text-base`}></i>
                </div>
              </div>

              <h3 className="text-[16px] text-foreground-800 tracking-[0.05em] font-medium mb-2">
                {lang === 'en' ? t(`pricingDetails.flow.${idx}.title`) : step.title}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                {lang === 'en' ? t(`pricingDetails.flow.${idx}.desc`) : step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 max-w-[650px] mx-auto">
          <div className="border-2 border-background-200 bg-background-100/50 p-5 md:p-6">
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-accent-500/10 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-error-warning-line text-accent-500 text-base"></i>
              </div>
              <div>
                {String(t('pricingDetails.flow.importantTitle')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[15px] text-foreground-800 tracking-[0.04em] font-medium mb-2">{__s}</p>))}
                <ul className="space-y-1.5 text-[14px] text-foreground-500 tracking-[0.03em]">
                  {(['note1', 'note2', 'note3', 'note4'] as const).map((key) => (
                    <li key={key} className="flex items-start gap-1.5">
                      <span className="text-foreground-400 flex-shrink-0">&#xb7;</span>
                      {t(`pricingDetails.flow.${key}`)}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
